import React from "react";
import Asset from "mibaby-frontend/media/Asset";
import { trackRaw } from "@components/click-tracker";

const MAX_IMAGE_WIDTH_SIZES_PROPERTY = "(min-width: 36em) 600px, 100vw";

export default ({
  teaserId = null,
  asset_mimetype,
  asset_versions,
  asset_options: { showPlayIcon = false } = {},
  asset_raw_image,
  imageProps,
}) => {
  const interactionName = "feed_video_play";
  let id = null;
  if (teaserId) {
    [, id] = teaserId.indexOf("_") === -1 ? [null, teaserId] : teaserId.split("_");
  }

  const onStart = () => {
    trackRaw("interaction", {
      i: interactionName,
      aid: id,
    });
  };

  const videoProps = { className: "content-feed-teaser-video", showPlayIcon };
  const assetProps = {
    mimeType: asset_mimetype,
    versions: asset_versions,
    videoProps: {
      ...videoProps,
      onStart,
    },
    imageProps: imageProps || {
      sizes: MAX_IMAGE_WIDTH_SIZES_PROPERTY,
    },
  };

  // when a raw image (just an url) is supplied,
  // try to transform it so that the Asset component
  // can display it.
  // It is important to set responsive to false, so that
  // no srcSet is used. then size is necessary, and the key
  // must be present in the versions.
  if (asset_raw_image) {
    assetProps.imageProps.responsive = false;
    assetProps.imageProps.size = "original";
    assetProps.mimeType = "image/jpeg";
    assetProps.versions = {
      original: asset_raw_image,
    };
  }

  return <Asset {...assetProps} />;
};
